module.exports = __webpack_public_path__ + "assets/img/help_sb1.9fce60f7.png";